module.exports = __webpack_public_path__ + "static/media/product_template_icon.f3418fc1.svg";